/**
 * Global-e free-shipping announcement: remove only zero cents from the
 * visible banner text. Currency conversion and shipping thresholds remain
 * owned by Global-e; cart and checkout are untouched.
 */
(function () {
  'use strict';

  var bannerSelector = '#FreeShippingBanner, .ge-free-shipping-msg';
  var bannerObserver;
  var observerRoot;
  var started = false;

  function hideZeroCents(text) {
    return text.replace(/(^|[^\d])(\d{1,3}(?:[.,'’ \u00a0\u202f]\d{3})+|\d+)[.,]00(?!\d)/g,
      function (match, prefix, amount) { return prefix + amount; });
  }

  function normalizeBanner(banner) {
    if (!banner || !banner.isConnected) return;

    var iterator = document.createTreeWalker(banner, NodeFilter.SHOW_TEXT);
    var textNode;
    while ((textNode = iterator.nextNode())) {
      var previous = textNode.nodeValue;
      if (previous && previous.indexOf('00') !== -1) {
        var corrected = hideZeroCents(previous);
        if (corrected !== previous) textNode.nodeValue = corrected;
      }
    }
  }

  function normalizeAll() {
    var banners = document.querySelectorAll(bannerSelector);
    for (var i = 0; i < banners.length; i++) normalizeBanner(banners[i]);
  }

  function touchesBanner(mutation) {
    var target = mutation.target.nodeType === Node.ELEMENT_NODE
      ? mutation.target : mutation.target.parentElement;

    if (target && target.closest && target.closest(bannerSelector)) return true;
    for (var i = 0; i < mutation.addedNodes.length; i++) {
      var node = mutation.addedNodes[i];
      if (node.nodeType !== Node.ELEMENT_NODE) continue;
      if ((node.matches && node.matches(bannerSelector)) ||
          (node.querySelector && node.querySelector(bannerSelector))) return true;
    }
    return false;
  }

  function start() {
    if (started) return;
    observerRoot = document.documentElement;
    if (!observerRoot) return;
    started = true;

    normalizeAll();
    bannerObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (touchesBanner(mutations[i])) {
          normalizeAll();
          break;
        }
      }
    });
    bannerObserver.observe(observerRoot, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  // Re-check when pages are replaced without a full reload by Shopify.
  document.addEventListener('shopify:section:load', normalizeAll);
})();
